/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SkeletonStyles from './SkeletonStyles';

const styles = (theme) => ({
    // Import Skeleton layout
    ...SkeletonStyles,
    // Page Elements
    root: {},

    productInfo: {
        '&--blockAddons': {
            margin: '10px 0',
            width: '100%',
            height: 50,
        },
    },
});

const PDPAddonSkeleton = ({ classes }) => (
    <div className={`${classes.productInfo}--blockAddons ${classes.block}`} />
);

PDPAddonSkeleton.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(PDPAddonSkeleton);
